<template>
<div id="index">

  <div class="common-seach-wrap">
    <el-form size="small" :inline="true" :model="searchObj">
      <!-- <el-form-item label="标题/品牌">
        <el-input v-model="searchObj.search" placeholder="请输入标题/品牌"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="手机号">
        <el-input v-model="searchObj.mobile" placeholder="请输入手机号"></el-input>
      </el-form-item> -->
      <!-- <el-form-item label="分类">
        <el-select v-model="searchObj.category_id" placeholder="请选择分类">
          <el-option value="" label="全部"></el-option>
          <el-option v-for="item in cateList" :key="item.id" :label="item.name" :value="item.category_id"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="状态">
        <el-select v-model="searchObj.status" placeholder="请选择状态">
          <el-option value="" label="全部"></el-option>
          <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="城市">
        <el-select v-model="searchObj.city_id" placeholder="请选择城市">
          <el-option value="" label="全部"></el-option>
          <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.city_id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="pageChange(1)">查询</el-button>
      </el-form-item>
    </el-form>
  </div>


  <!-- <div class="common-level-rail">
    <el-button size="small" type="primary" @click="$refs.addEdit.show()" icon="el-icon-plus" v-auth="'/appraisal/appraisal/add'">添加成色</el-button>
  </div> -->

  <div class="product-content">
    <div class="table-wrap">
      <el-table size="small" :data="list">
        <el-table-column  label="需求用户" width="200">
          <template slot-scope="scope">
            <div class="userInfo">
              <img :src="scope.row.user.avatarUrl" alt="">
              <div class="main">
                <p class="name">{{ scope.row.user.nickName }}</p>
                <p class="text">ID:{{ scope.row.user.user_id }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="credit.name" label="征信信息"></el-table-column>
        <el-table-column prop="age" label="年龄"></el-table-column>
        <el-table-column prop="city.name" label="城市"></el-table-column>
        <el-table-column prop="money" label="所需额度(元)"></el-table-column>
        <el-table-column label="业务类型">
          <template slot-scope="scope">
            {{scope.row.business.map(item=>item.name).join('、')}}
          </template>
        </el-table-column>
        <el-table-column label="文件信息" width="220px">
          <template slot-scope="scope">
            <el-image v-for="(item,index) in scope.row.images.slice(0,3)" :key="index" :src="item.file_path" fit="fill" :preview-src-list="scope.row.images.map(item=>item.file_path)" ></el-image>
            <span v-if="scope.row.images.length>3">更多...</span>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <el-tag size="small" v-if="scope.row.status=='10'" type="success">对单中</el-tag>
            <el-tag size="small" v-else-if="scope.row.status=='20'" type="warning">已完结</el-tag>
            <el-tag size="small" v-else type="danger">已关闭</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="create_time" label="添加时间"></el-table-column>
        <el-table-column fixed="right" label="操作" width="160px">
          <template slot-scope="scope">
            <el-button @click="$refs.addEdit.show(scope.row)" type="text" size="small" v-auth="'/need/need/edit'">编辑</el-button>
            <el-button @click="deleteItem(scope.row)" type="text" size="small" v-auth="'/need/need/delete'">删除</el-button>
            <el-button v-if="scope.row.status==30||scope.row.status==10"  @click="changeStatus(scope.row)" type="text" size="small" v-auth="'/need/need/status'">{{ scope.row.status=='10'?'下架':'上架' }}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>

  <div class="pagination">
    <el-pagination
      @current-change="pageChange"
      background
      :current-page="searchObj.page"
      :page-size="searchObj.list_rows"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>


  <AddEdit ref="addEdit" @refresh="getData" :creditList="creditList" :cityList="cityList" :businessList="businessList"></AddEdit>


</div>
</template>

<script>
import AddEdit from './addEdit.vue';
import NeedApi from '@/api/need'
import { MAIN_KEY, fetchLabelValueOptions, FALLBACK_NEED_STATUS_LIST } from '@/utils/sysEnumOptions'
export default {
  components:{AddEdit},
  data() {
    return {
      searchObj:{
        page:1,
        list_rows:10,
        // search:'',
        // mobile:'',
        // category_id:'',
        city_id:'',
        status:'',
      },
      list: [],
      total:0,
      // cateList:[],
      cityList:[],
      businessList:[],
      creditList:[],
      statusList: [...FALLBACK_NEED_STATUS_LIST],
    }
  },
  created(){
    fetchLabelValueOptions(MAIN_KEY.needListStatus, { stringValue: true }, FALLBACK_NEED_STATUS_LIST)
      .then(list => { this.statusList = list })
      .catch(() => {})
    this.getData()
    // this.getCateList()
    this.getCityList()
    this.getCreditList()
    this.getBusinessList()
  },
  methods:{

    getData(){
      NeedApi.needIndex(this.searchObj).then(result=>{
        let list=result.data.need
        this.list=list.data
        this.total=list.total
      })
    },

    // 获取征信情况列表
    getCreditList(){
      NeedApi.creditAll().then(result=>{
        let list=result.data.credit
        this.creditList=list
      })
    },

    getBusinessList(){
      NeedApi.businessAll().then(result=>{
        let list=result.data.business
        this.businessList=list
      })
    },

    // 获取城市列表
    getCityList(){
      NeedApi.cityAll().then(result=>{
        let list=result.data.list
        this.cityList=list
      })
    },

    // 删除
    deleteItem(e){
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        NeedApi.needDelete({need_id:e.need_id}).then(result=>{
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getData()
        })
      })
    },

    // 上下架
    changeStatus(e){
      this.$confirm('确定'+(e.status=='10'?'下架':'上架')+'吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        NeedApi.needStatus({need_id:e.need_id,status:e.status=='10'?'30':'10'}).then(result=>{
          this.$message({
            message: (e.status=='10'?'下架':'上架')+'成功',
            type: 'success'
          })
          this.getData()
        })
      })
    },

    // 分页
    pageChange(e){
      this.searchObj.page=e
      this.getData()
    },

  }
}
</script>

<style lang="scss" scoped>
.userInfo{display: flex;
  img{width: 40px;height: 40px;}
  .main{flex: 1;padding-left: 10px;
    .name{font-weight: bold;}
    .text{color:#999;}
  }
}
.el-image{width: 50px;height: 50px;}
</style>



// WEBPACK FOOTER //
// src/views/need/need/index.vue